import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Collapse, Typography } from 'antd';
import React, { useState } from 'react';
import CommitteeRisk from './CommitteeRisk/CommitteeRisk';
import * as S from './DealRoomSection.styles';
import { PanelItem } from './ThirdPartyInsurance';

const { Title, Text } = Typography;
export const { Panel } = Collapse;

const InsuranceCover: React.FC = () => {
  return (
    <>
      <S.ContentTextWrapper>
        <Text className="sub-text">{`הביטוח מכסה נזקים לאזורים המשותפים במקרים הבאים:`}</Text>
        <S.ListWrapper>
          <S.ListItem>{`רעידת אדמה`}</S.ListItem>
          <S.ListItem>{`שריפה`}</S.ListItem>
          <S.ListItem>{`התפוצצות גז`}</S.ListItem>
          <S.ListItem>{`פיצוץ צנרת`}</S.ListItem>
          <S.ListItem>{`נזקי סערה או סופה`}</S.ListItem>
          <S.ListItem>{`פגיעת כלי רכב`}</S.ListItem>
          <S.ListItem>{`נזק בזדון שלא נעשה על ידי בעלי ובעלות הדירות עצמם`}</S.ListItem>
          <S.ListItem>{`גניבה או פריצה`}</S.ListItem>
          <S.ListItem>{`שטפון או הצפה ממקור מים חיצוני לבניין`}</S.ListItem>
          <S.ListItem>{`שבר שמשות ומראות.`}</S.ListItem>
        </S.ListWrapper>
      </S.ContentTextWrapper>

      <S.ContentTextWrapper className="mt-24">
        <Title level={2} className="main-title regular">
          {`מקרים ביטוחיים לדוגמה:`}
        </Title>
        <S.ListWrapper>
          <S.ListItem>{`שריפה פרצה באחת הדירות בבניין, האש התפשטה במהירות דרך חלונות הדירה ושרפה את כל הקיר החיצוני של הבניין. עלות התיקון הוערכה במיליוני שקלים ובעל הדירה רכש ביטוח דירה ללא כיסוי צד ג'. פרק המבנה של ביטוח הבית המשותף מכסה את כל נזקי השריפה של הרכוש המשותף, ללא קשר למקור וגורם השריפה.`}</S.ListItem>
          <S.ListItem>{`צינור כיבוי אש התפוצץ בקומה גבוהה והציף את כל הבניין. במקום לא נכח אף אחד שידע כיצד לכבות את המערכת במשך זמן רב, שבמהלכו נגרמו נזקים רבים, כולל השבתת המעליות. פרק המבנה של ביטוח הבית המשותף מכסה נזקי צנרת של הרכוש המשותף, כולל צנרת כיבוי אש.`}</S.ListItem>
        </S.ListWrapper>
      </S.ContentTextWrapper>
    </>
  );
};

const InsuranceNotCover: React.FC = () => {
  return (
    <>
      <S.ContentTextWrapper>
        <Text className="sub-text">{`כל נזק שלא מצוין מעלה – אינו מכוסה.`}</Text>
      </S.ContentTextWrapper>

      <S.ContentTextWrapper className="mt-24">
        <Title level={2} className="main-title regular">
          {`מקרים ביטוחיים לדוגמה:`}
        </Title>
        <Text className="sub-text">{`בעיות איטום, בלאי מצטבר, תחזוקה שוטפת, חלחול מי גשמים, תקלות במערכות הבניין.`}</Text>
      </S.ContentTextWrapper>
    </>
  );
};

const FAQs: React.FC = () => {
  return (
    <>
      <S.ContentTextWrapper>
        <S.ListWrapper className="number">
          <S.ListItem>
            <S.ListTitle>
              {`הבניין שלנו יחסית חדש ומערכות הבניין שלנו במצב מצוין, האם אנו זקוקים`}
              <br />
              {`בכל זאת לביטוח מבנה?`}
            </S.ListTitle>
            <S.ListContent>{`כן. ביטוח מבנה אינו מכסה בלאי טבעי של הבניין ואינו קשור למצב המערכות בבניין. הביטוח מכסה`}</S.ListContent>
            <S.ListContent>{`נזקים בלתי צפויים שעלות תיקונם עלולה להסתכם במאות אלפי שקלים. לדוגמה:`}</S.ListContent>
            <S.ListContent>
              <S.ListWrapper className="normal-number">
                <S.ListItem>
                  <S.ListContent>{`שריפה שפורצת בבניין גורמת את אותו הנזק הן לבניין חדש והן לבניין ישן.`}</S.ListContent>
                </S.ListItem>
                <S.ListItem>
                  <S.ListContent>{`פיצוץ צנרת הגורם להצפה של המעליות משבית מעלית ישנה וחדשה כאחד.`}</S.ListContent>
                </S.ListItem>
                <S.ListItem>
                  <S.ListContent>{`עובד של חברת הובלה פוגע בטעות בספרינקלר קומתי ומים פורצים ומציפים את מעליות הבניין.`}</S.ListContent>
                </S.ListItem>
              </S.ListWrapper>
            </S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListTitle>{`התפוצץ צינור של הבניין ומים גרמו נזק למעלית, האם הביטוח מכסה?`}</S.ListTitle>
            <S.ListContent>{`כן, פוליסת מבנה לרכוש המשותף כוללת גם כיסוי נזקי מים למעלית, כל עוד בחרת לא לוותר על הסעיף של נזקי צנרת.`}</S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListTitle>{`אם יש לי ביטוח דירה מדוע אני צריך לרכוש ביטוח מבנה לבית המשותף?`}</S.ListTitle>
            <S.ListContent>{`פוליסת מבנה לרכוש המשותף מכסה את השטחים המשותפים בסכומי ביטוח תואמים לרכוש המשותף. לא כל הדיירים רוכשים ביטוח לדירה הפרטית שלהם ולא כולם רוכשים ביטוח בסכום מתאים. קשה עד בלתי אפשרי לוועד הבית לוודא ולעקוב אחרי כל ביטוח דירה פרטי. בנוסף, בעת נזק, ועד הבית ירצה פיצוי כמה שיותר מהיר על מנת לשקם את הרכוש המשותף, ולהתנהל מול כל ביטוח דירה פרטי של דייר כזה או אחר יהיה סיוט בירוקרטי.`}</S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListTitle>{`יש לי בבניין חניון תת-קרקעי, האם ביטוח מבנה מכסה נזקים שייגרמו לחניון?`}</S.ListTitle>
            <S.ListContent>{`כן. ביטוח מבנה מיועד לחלקים המשותפים בבניין, ביניהם גם חניון תת קרקעי.`}</S.ListContent>
            <S.ListContent>{`חשוב לשים לב שסכום הביטוח בפרק מבנה כולל את החניון התת קרקעי.`}</S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListTitle>{`המשאבה בבניין לא עובדת, האם הביטוח מכסה?`}</S.ListTitle>
            <S.ListContent>{`לא. ביטוח מבנה לא מכסה קלקול/בלאי. פרק מבנה מכסה נזק תאונתי הרשום בפוליסה.`}</S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListTitle>{`האם ביטוח מבנה הבית המשותף מכסה גם נזקים שנגרמו לדירות?`}</S.ListTitle>
            <S.ListContent>{`לא. על כל בעל דירה לדאוג לביטוח דירה פרטי. אולם אם מקור הנזק הוא הרכוש המשותף ומדובר ברשלנות של הבניין אזי ביטוח צד ג׳ לרכוש המשותף יכסה את הנזקים לדירות, וביטוח מבנה לרכוש המשותף יכסה נזקים לרכוש המשותף.`}</S.ListContent>
          </S.ListItem>
        </S.ListWrapper>
      </S.ContentTextWrapper>
    </>
  );
};

const panelItems: PanelItem[] = [
  {
    key: '1',
    title: 'מה הביטוח מכסה?',
    content: <InsuranceCover />,
  },
  {
    key: '2',
    title: `מה הביטוח לא מכסה?`,
    content: <InsuranceNotCover />,
  },
  {
    key: '3',
    title: `שאלות ותשובות נפוצות`,
    content: <FAQs />,
  },
  {
    key: '4',
    title: `פרצה שריפה? חברי ועד הבית חשופים לתביעת רשלנות`,
    content: <CommitteeRisk />,
  },
];
export const SharedBuildingStructure: React.FC = () => {
  const [activeKey, setActiveKey] = useState<string | string[]>();

  return (
    <S.Wrapper>
      <S.Header>
        <Title level={2} className="main-title">
          {`ביטוח מבנה לבית המשותף`}
        </Title>
        <Title level={2} className="main-title">{`למה צריך ביטוח מבנה לבית המשותף?`}</Title>
        <Text className="sub-text">{`ביטוח מבנה לבית המשותף הוא מהחשובים שבביטוחים עבור ועדי בתים. הוא מכסה נזקים באזורים המשותפים של הבניין, בהם: חדר מדרגות, מעליות, לובי, חדר אשפה, חנייה ועוד. נזקים באזורים אלו יכולים להתחיל בעלות של אלפי שקלים ולהגיע עד מיליוני שקלים!
אם הבניין לא מכוסה בביטוח מבנה - בעלי ובעלות הדירות יאלצו לשלם את הסכומים האלו מכיסם.`}</Text>
      </S.Header>
      <S.IconCollapseWrapper>
        <S.IconCollapse accordion className="custom-collapse" activeKey={activeKey} onChange={setActiveKey}>
          {panelItems.map((item) => (
            <Panel
              key={item.key}
              showArrow={false}
              header={
                <S.PanelHeader>
                  <S.IconWrapper>
                    {activeKey === item.key ? (
                      <MinusOutlined className="plus-icon" />
                    ) : (
                      <PlusOutlined className="plus-icon" />
                    )}
                  </S.IconWrapper>
                  <Text strong className="header-text">
                    {item.title}
                  </Text>
                </S.PanelHeader>
              }
            >
              {item.content}
            </Panel>
          ))}
        </S.IconCollapse>
      </S.IconCollapseWrapper>
    </S.Wrapper>
  );
};
